module.exports = __webpack_public_path__ + "static/media/15UN-Habitat13.bec1f6b5.jpg";